import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaBook } from "react-icons/fa6";
import TrainingModules from "./index";
import ViewTrainingModule from "./view";
import EditTrainingModule from "./edit";
import { MODULE_TRAINING_MOD } from "variables/constants";

const trainingModuleRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Modules",
		basePath: "training-modules",
		mainComponent: <TrainingModules />,
	    layout: "/console",	   
	    icon: <FaBook className="icon-item" />,
	    subTitle:"Training Module",
	    viewComponent: <ViewTrainingModule />,
	    createComponent: <EditTrainingModule />,
	    editComponent: <EditTrainingModule />,
		level:5,
		moduleId: MODULE_TRAINING_MOD,
	})
]

export default trainingModuleRoutes;